<template>
    <v-container class="pa-5" fluid>
        <WorkspaceSettingsDialog
            :is-open="workspaceSettingsDialog"
            :workspace-id-data="workspaceId"
            :workspaces="workspaces"
            @on-save="saveWorkspaceSettings"
            @on-abort="closeWorkspaceSettingsDialog"
        />

        <v-row dense>
            <v-col cols="auto">
                <page-title>Generator etykiet rewizyjnych</page-title>
            </v-col>
        </v-row>
        <v-row align="center">
            <v-col class="pb-0">
                <v-btn
                    text
                    color="primary"
                    class="pa-0"
                    @click="close"
                >
                    <v-icon color="primary">
                        mdi-arrow-left
                    </v-icon>
                    Powrót
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-container>
                    <v-row justify="end">
                        <v-col cols="12" sm="6" md="4" lg="4" xl="3">
                            <v-card>
                                <v-toolbar flat dense color="grey lighten-4">
                                    <v-container class="pa-0">
                                        <v-row justify="space-between" dense align="center">
                                            <v-col>
                                                <v-toolbar-title class="text-subtitle-1">
                                                    Stanowisko
                                                </v-toolbar-title>
                                            </v-col>
                                            <v-col cols="auto">
                                                <v-tooltip :open-delay="tooltipDelay" top>
                                                    <template #activator="{on}">
                                                        <v-btn
                                                            v-if="canChangeWorkspace"
                                                            fab
                                                            x-small
                                                            color="secondary"
                                                            elevation="1"
                                                            :loading="actionLoading.workspaces"
                                                            v-on="on"
                                                            @click="showWorkspaceSettingsDialog(false)"
                                                        >
                                                            <v-icon>
                                                                mdi-printer-3d
                                                            </v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Zmiana stanowiska</span>
                                                </v-tooltip>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-toolbar>

                                <v-divider />

                                <v-card-text class="py-8 text-center">
                                    <div class="text-h3 font-weight-bold black--text">
                                        {{ currentWorkspace ? currentWorkspace.name : '-' }}
                                    </div>
                                </v-card-text>
                                <v-col cols="12">
                                    <v-select
                                        v-model="printerId"
                                        :items="printers"
                                        item-value="id"
                                        item-text="name"
                                        label="Drukarka"
                                        hide-details
                                        no-data-text="Nie znaleziono drukarki"
                                        outlined
                                        dense
                                    />
                                </v-col>
                            </v-card>
                        </v-col>
                    </v-row>

                    <v-divider />
                    
                    
                    <v-row>
                        <v-col cols="12">
                            <v-card>
                                <v-card-text>
                                    <v-col cols="12">
                                        <v-row justify="space-between">
                                            <v-col cols="4">
                                                <v-text-field
                                                    v-model="labelData.customer"
                                                    label="Klient"
                                                    readonly
                                                    outlined
                                                    dense
                                                    required
                                                />
                                            </v-col>
                                            <v-col cols="4">
                                                <v-text-field
                                                    ref="numberField"
                                                    v-model="objectToFind.number"
                                                    label="Numer"
                                                    hint="Proszę zeskanować kartę lub wpisać cały numer."
                                                    outlined
                                                    dense
                                                    required
                                                    clearable
                                                    autofocus
                                                    @click:clear="clearData()"
                                                />
                                            </v-col>
                                        </v-row>
                                        <v-row justify="space-between">
                                            <v-col cols="4">
                                                <v-text-field
                                                    v-model="labelData.jobNumber"
                                                    label="Numer zlecenia"
                                                    readonly
                                                    outlined
                                                    dense
                                                    required
                                                />
                                            </v-col>
                                            <v-col cols="12" sm="6" md="4" lg="4" xl="3">
                                                <v-select
                                                    v-model="objectToFind.type"
                                                    label="Typ obiektu"
                                                    :items="objectsToSearch"
                                                    item-value="type"
                                                    item-text="verboseName"
                                                    no-data-text="Nie znaleziono obiektów"
                                                    outlined
                                                    dense
                                                    required
                                                />
                                            </v-col>
                                        </v-row>
                                        <v-row justify="space-between">
                                            <v-col cols="4">
                                                <v-select
                                                    v-model="labelData.product"
                                                    label="Produkt"
                                                    :items="products"
                                                    item-value="name"
                                                    item-text="name"
                                                    no-data-text="Nie znaleziono produktów"
                                                    outlined
                                                    dense
                                                    required
                                                    @change="changeProduct"
                                                />
                                            </v-col>
                                            <v-col cols="auto">
                                                <v-btn
                                                    color="primary"
                                                    medium
                                                    data-sentry-label="Szukaj obiektu"
                                                    :loading="actionLoading.search"
                                                    :disabled="!readyToSearch"
                                                    @click="getDetails()"
                                                >
                                                    Szukaj
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                        <v-row justify="space-between">
                                            <v-col cols="4">
                                                <v-text-field
                                                    v-model="labelData.createdAt"
                                                    label="Data"
                                                    readonly
                                                    outlined
                                                    dense
                                                    hide-details
                                                />
                                            </v-col>
                                            <v-col cols="auto">
                                                <v-btn
                                                    color="primary"
                                                    medium
                                                    data-sentry-label="Drukuj etykietę rewizyjną"
                                                    :disabled="!readyToPrint"
                                                    :loading="actionLoading.printLabel"
                                                    @click="printLabel()"
                                                >
                                                    <v-icon left>
                                                        mdi-printer
                                                    </v-icon>
                                                    Drukuj etykietę
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import decodeQRcode from '@/mixins/decodeQRcode'
import customFilters from '@/mixins/customFilters'
import store from '@/./store'
import router from '@/router'
import PageTitle from '@/components/common/PageTitle'
import { appConfig } from '@/config'


import WorkspaceSettingsDialog from './WorkspaceSettingsDialog'
import tooltipDelay from '@/mixins/tooltip'
import { errorHandler, addSentryBreadcrumb } from '@/utils/errorHandler'
import { hasUserPermission } from '@/utils/permissionsHandler'

export default {
    name: 'RevisoryLabels',
    components: {
        PageTitle,
        WorkspaceSettingsDialog
    },
    mixins: [
        decodeQRcode,
        tooltipDelay,
        customFilters
    ],
    beforeRouteEnter(to, from, next) {
        store.dispatch('configurations/getProductionSites', {query:'?type_id=6'})
            .then(() => {
                next(vm => {
                    const workspace = JSON.parse(localStorage.getItem('revisoryLabelsWorkspace'))

                    if (!workspace) {
                        vm.showWorkspaceSettingsDialog()
                    } else {
                        vm.workspaceId = workspace.workspaceId
                        vm.setRevisoryLabelsSettings(vm.workspaceId)
                    }
                })
            })
            .catch(error => {
                next(error)
                errorHandler(error)
            })
    },
    data() {
        return {
            search: '',
            labelData: {
                jobNumber: null,
                customer: null,
                product: null,
                createdAt: null
            },
            labelToPrint: {},
            objectToFind: {
                type: 'KZ',
                number: null
            },
            settings : {
                workspace: null
            },
            actionLoading: {
                workspaces: false,
                search: false,
                printLabel: false,
            },
            workspaceId: null,
            workspaceSettingsDialog: false,
            printerId: null,
            products: [],

        }
    },
    computed: {
        objectsToSearch() {
            return appConfig.labels.revisoryLabelObjects
        },
        workspaces() {
            return this.$store.state.configurations.productionSites.productionSites
        },
        currentWorkspace() {
            return this.revisoryLabelsSettings?.workspace
        },
        printers() {
            if (this.currentWorkspace) {
                return this.currentWorkspace.printers
            }

            return []
        },
        revisoryLabelsSettings() {
            return this.$store.state.shipments.labelsGenerator.labelsGenerator.revisoryLabelsSettings
        },
        canChangeWorkspace() {
            return hasUserPermission('production_sites_admin_update')
        },
        readyToPrint() {
            const values = Object.values(this.labelData)

            return values.every(value => value !== null) && this.readyToSearch
        },
        readyToSearch() {
            return this.objectToFind.number && this.objectToFind.type
        },
    },
    created() {
        document.addEventListener('keydown', this.QRtoJSON)
    },
    destroyed() {
        document.removeEventListener('keydown', this.QRtoJSON)
    },
    methods: {
        setDefaultPrinter(workspace) {
            if (workspace) {
                if (workspace.printerId) {
                    return this.printerId = workspace.printerId
                } else if (workspace.printers.length > 0) {
                    return this.printerId = workspace.printers[0].id
                }
            }

            return null
        },
        setRevisoryLabelsSettings(workspaceId) {
            this.getWorkspace(workspaceId).then(response => {
                this.workspaceId = response.data.id
                localStorage.setItem('revisoryLabelsWorkspace', JSON.stringify({
                    'workspaceId': workspaceId,
                }))
                this.settings.workspace = response.data
                store.dispatch('shipments/labelsGenerator/setRevisoryLabelsSettings', this.settings)
                this.setDefaultPrinter(this.settings.workspace)
            })
        },
        async getWorkspace(workspaceId) {
            return await this.$store.dispatch('configurations/getProductionSite', workspaceId)
                .catch(error => {
                    errorHandler(error)
                })
        },
        showWorkspaceSettingsDialog() {
            this.actionLoading.workspaces = true
            addSentryBreadcrumb('ui.action', 'Ustawienia stanowiska')

            this.$store.dispatch('configurations/getProductionSites', {query:'?type_id=6'})
                .then(() => {
                    this.workspaceSettingsDialog = true
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.actionLoading.workspaces = false
                })
        },
        closeWorkspaceSettingsDialog() {
            this.workspaceSettingsDialog = false
            this.clearData()
            this.$nextTick(() => {
                this.$refs.numberField.focus()
                this.objectToFind.number = null
            })
        },
        saveWorkspaceSettings(value) {
            this.setRevisoryLabelsSettings(value)
            this.closeWorkspaceSettingsDialog()
        },
        handleQrJSON({ data }) {
            this.clearData()

            if (data.type === 'KZ') {
                this.objectToFind.type = 'KZ'
                this.objectToFind.number = data.taskNumber
            } else {
                this.objectToFind.type = 'KP'
                this.objectToFind.number = data.order
            }

            this.getDetails()
        },
        changeProduct(value) {
            this.labelToPrint.product = value
        },
        clearData() {
            this.labelData = {
                jobNumber: null,
                customer: null,
                product: null,
                createdAt: null
            },
            this.labelToPrint = {}
        },
        setLabelToPrintData() {
            this.labelToPrint.client = this.labelData.customer
            this.labelToPrint.printerId = this.printerId
            this.labelToPrint.product = this.labelData.product.name
            this.labelToPrint.jobNumber = this.labelData.jobNumber
        },
        printLabel() {
            this.actionLoading.printLabel = true
            this.$store.dispatch('shipments/labelsGenerator/setGenerateRevisionLabel', this.labelToPrint)
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.actionLoading.printLabel = false
                })
        },
        getDetails() {
            this.actionLoading.search = true
            this.$store.dispatch('shipments/labelsGenerator/getRevisionLabelDetails', this.objectToFind)
                .then(response => {
                    const responseData = response.data

                    this.labelData.customer = responseData.customer
                    this.labelData.createdAt = responseData.createdAt
                    this.labelData.jobNumber = responseData.jobNumber

                    this.products = responseData.products
                    this.labelData.product = this.products[0]
                    this.setLabelToPrintData()
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.actionLoading.search = false
                })
        },
        close() {
            router.push({ name: 'ShippingLabelsGeneratorAll' })
                .catch(error => {
                    errorHandler(error)
                })
        },
    }
}
</script>